module.exports = __webpack_public_path__ + "static/media/Dexter.63b07ed4.svg";